import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Skeleton,
  Box,
} from '@mui/material';
import { PieChart, Pie, Tooltip, Cell, Legend, ResponsiveContainer } from 'recharts';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0];
      return (
        <Box sx={{ backgroundColor: 'white', border: '1px solid #ccc', padding: 1, borderRadius: 1 }}>
          <Typography variant="body2" fontWeight="bold">{name}</Typography>
          <Typography variant="body2">💰 Ventas: {formatMoney(value)}</Typography>
        </Box>
      );
    }
    return null;
};  

const BranchParticipationPieChart = ({ data = [], branches = [], loading }) => {
  const chartData = data.map((item) => {
    const branch = branches.find((b) => b.id === item.branchId);
    return {
      name: branch ? (branch.deleted ? `${branch.name} (eliminada)` : branch.name) : `Sucursal ${item.branchId}`,
      deleted: !!branch?.deleted,
      value: item.value,
      fill: branch?.color || '#ccc',
    };
  });

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          % de participación por sucursal ($)
        </Typography>

        {loading ? (
          <Skeleton variant="rectangular" height={300} />
        ) : chartData.length > 0 ? (
          <Box height={300}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  label={({ value }) => `${formatMoney(value)}`}
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} fillOpacity={entry.deleted ? 0.4 : 1} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend verticalAlign="bottom" height={36} />
              </PieChart>
            </ResponsiveContainer>
          </Box>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No hay datos disponibles para mostrar.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default BranchParticipationPieChart;
